import React, { useState, createContext, useContext } from 'react';
type Language = 'en' | 'th';
type Translations = { [key in Language]: {
  nav: {
    home: string;
    businesses: string;
    about: string;
    contact: string;
    reserve: string;
  };
  hero: {
    subtitle: string;
    title1: string;
    title2: string;
    description: string;
    explore: string;
    contact: string;
  };
  businesses: {
    label: string;
    title: string;
    description: string;
  };
  testimonials: {
    label: string;
    title: string;
  };
  newsletter: {
    label: string;
    title: string;
    description: string;
    placeholder: string;
    button: string;
    disclaimer: string;
  };
  footer: {
    description: string;
    quickLinks: string;
    contact: string;
    rights: string;
    design: string;
  };
  common: {
    viewDetails: string;
    readMore: string;
    learnMore: string;
    backToPortfolio: string;
    overview: string;
    gallery: string;
    filmography: string;
    tvcs: string;
    reviews: string;
    contactInfo: string;
    address: string;
    phone: string;
    email: string;
    website: string;
    hours: string;
    capacity: string;
    established: string;
  };
} };
const translations: Translations = {
  en: {
    nav: {
      home: 'Home',
      businesses: 'Our Businesses',
      about: 'About',
      contact: 'Contact',
      reserve: 'Reserve Now'
    },
    hero: {
      subtitle: 'Premium Entertainment & Luxury Hospitality',
      title1: 'Experience Premium.',
      title2: 'Taste Excellence.',
      description: 'Discover our diverse portfolio spanning premium film production and exceptional hospitality venues across Thailand.',
      explore: 'Explore Portfolio',
      contact: 'Get in Touch'
    },
    businesses: {
      label: 'Our Collection',
      title: 'Our Businesses',
      description: '17 exceptional venues across Thailand, each offering a unique experience defined by quality and authenticity.'
    },
    testimonials: {
      label: 'Testimonials',
      title: 'What People Say'
    },
    newsletter: {
      label: 'Stay Connected',
      title: 'Join Our Exclusive List',
      description: 'Subscribe for new openings, VIP events, and exclusive offers delivered to your inbox.',
      placeholder: 'Enter your email address',
      button: 'Subscribe',
      disclaimer: 'By subscribing, you agree to our Privacy Policy. No spam, ever.'
    },
    footer: {
      description: 'Premier hospitality management company with a diverse portfolio of restaurants and entertainment venues across Thailand. Defining luxury since 2004.',
      quickLinks: 'Quick Links',
      contact: 'Contact Us',
      rights: '© 2026 BV Group Hospitality. All rights reserved.',
      design: 'Design by Custom Service Solutions • AG'
    },
    common: {
      viewDetails: 'View Details',
      readMore: 'Read More',
      learnMore: 'Learn More',
      backToPortfolio: 'Back to Portfolio',
      overview: 'Overview',
      gallery: 'Gallery',
      filmography: 'Filmography',
      tvcs: 'Television Commercials',
      reviews: 'Guest Reviews',
      contactInfo: 'Contact Information',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      website: 'Website',
      hours: 'Hours',
      capacity: 'Capacity',
      established: 'Established'
    }
  },
  th: {
    nav: {
      home: 'หน้าแรก',
      businesses: 'ธุรกิจของเรา',
      about: 'เกี่ยวกับเรา',
      contact: 'ติดต่อเรา',
      reserve: 'จองเลย'
    },
    hero: {
      subtitle: 'ความบันเทิงระดับพรีเมียมและการต้อนรับที่หรูหรา',
      title1: 'สัมผัสประสบการณ์ระดับพรีเมียม',
      title2: 'ลิ้มรสความเป็นเลิศ',
      description: 'ค้นพบพอร์ตโฟลิโอที่หลากหลายของเรา ครอบคลุมการผลิตภาพยนตร์ระดับพรีเมียมและสถานที่ต้อนรับที่ยอดเยี่ยมทั่วประเทศไทย',
      explore: 'สำรวจผลงาน',
      contact: 'ติดต่อเรา'
    },
    businesses: {
      label: 'คอลเลกชันของเรา',
      title: 'ธุรกิจของเรา',
      description: '17 สถานที่ยอดเยี่ยมทั่วประเทศไทย แต่ละแห่งมอบประสบการณ์ที่ไม่เหมือนใครซึ่งกำหนดโดยคุณภาพและความเป็นของแท้'
    },
    testimonials: {
      label: 'ความคิดเห็น',
      title: 'สิ่งที่ผู้คนพูดถึง'
    },
    newsletter: {
      label: 'เชื่อมต่อกับเรา',
      title: 'เข้าร่วมรายการพิเศษของเรา',
      description: 'สมัครรับข่าวสารการเปิดตัวใหม่ กิจกรรม VIP และข้อเสนอพิเศษส่งตรงถึงกล่องจดหมายของคุณ',
      placeholder: 'กรอกอีเมลของคุณ',
      button: 'สมัครสมาชิก',
      disclaimer: 'การสมัครสมาชิกแสดงว่าคุณยอมรับนโยบายความเป็นส่วนตัวของเรา ไม่มีสแปมตลอดไป'
    },
    footer: {
      description: 'บริษัทจัดการการต้อนรับชั้นนำที่มีพอร์ตโฟลิโอร้านอาหารและสถานบันเทิงที่หลากหลายทั่วประเทศไทย นิยามความหรูหราตั้งแต่ปี 2004',
      quickLinks: 'ลิงก์ด่วน',
      contact: 'ติดต่อเรา',
      rights: '© 2026 BV Group Hospitality. สงวนลิขสิทธิ์',
      design: 'ออกแบบโดย Custom Service Solutions • AG'
    },
    common: {
      viewDetails: 'ดูรายละเอียด',
      readMore: 'อ่านเพิ่มเติม',
      learnMore: 'เรียนรู้เพิ่มเติม',
      backToPortfolio: 'กลับสู่ผลงาน',
      overview: 'ภาพรวม',
      gallery: 'แกลเลอรี',
      filmography: 'ผลงานภาพยนตร์',
      tvcs: 'โฆษณาทางโทรทัศน์',
      reviews: 'รีวิวจากแขก',
      contactInfo: 'ข้อมูลการติดต่อ',
      address: 'ที่อยู่',
      phone: 'โทรศัพท์',
      email: 'อีเมล',
      website: 'เว็บไซต์',
      hours: 'เวลาทำการ',
      capacity: 'ความจุ',
      established: 'ก่อตั้งเมื่อ'
    }
  }
};
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations['en'];
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('en');
  const value = {
    language,
    setLanguage,
    t: translations[language]
  };
  return <LanguageContext.Provider value={value} data-id="element-356">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}